// eslint-disable
import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
  CircularProgress,
} from "@mui/material";
import Textarea from "@mui/joy/Textarea";
import { HarinessPost } from "../Blowroom/mutation/manager/blowroomReportMutation";
import { useMutation, useQueryClient } from "react-query";
import { handleToastMsg } from "../../components/Toast";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  createHairnessDraft,
  updateHairnessDraft,
} from "./mutation/harinessMutation";
import "./spinningcss.css";
const CountChange = () => {
  const queryClient = useQueryClient();
  const [formValues, setFormValues] = useState({
    counts: "",
    machineNo: "",
    feedback: "",
  });

  const { state } = useLocation();

  const [showData, setShowData] = useState([]);
  useEffect(() => {
    if (state?.HarinessPayload) {
      setShowData([state?.HarinessPayload]);
    }
  }, [state]);

  const handleFormChange = (event, field) => {
    let { value } = event.target;

    if (field === "feedback") {
      value = value.toUpperCase();
    } else if (["counts"].includes(field)) {
      value = !isNaN(value) ? parseFloat(value) : value;
    }
    setFormValues((prevState) => ({ ...prevState, [field]: value }));

    if (field === "feedback") {
      setShowData((prev) => {
        return prev.map((item) => {
          // Update the cot_buffing property of the specific item
          return {
            ...item,
            hairness_errors: {
              ...item.hairness_errors,
              feedback: value,
            },
          };
        });
      });
    }
  };

  const { mutate, isLoading: isSubmitLoading } = useMutation(HarinessPost);
  // const {
  //   data: varietyData,
  //   isLoading,
  //   isError,
  // } = useQuery("get-variety", () => getVariety(), {
  //   refetchOnMount: true,
  // });

  const { mutate: createDraft, isLoading: isCreateLoading } = useMutation(
    async (payload) => {
      try {
        const response = await createHairnessDraft(payload);
        return response;
      } catch (error) {
        throw error;
      }
    }
  );

  const { mutate: updateDraft, isLoading: isUpdateLoading } = useMutation(
    async (params) => {
      try {
        const response = await updateHairnessDraft(params);
        return response;
      } catch (error) {
        throw error;
      }
    }
  );

  // const {
  //   data: draftData,
  //   isLoading: isDraftLoading,
  //   isError: isDraftError,
  // } = useQuery(
  //   ["hairness-draft", draftId],
  //   async () => {
  //     try {
  //       const response = await getHairnessDraft();
  //       const transformedData = transformKeys(response.data);
  //       // setFormValues()
  //       return transformedData;
  //     } catch (error) {
  //       throw error;
  //     }
  //   },
  //   {
  //     refetchOnMount: true,
  //   }
  // );

  const navigate = useNavigate();

  const handleSaveAndEdit = () => {
    if (state?.draftId && state?.harinessDrafts) {
      const id = state?.draftId || "";
      const payload = showData[0];
      const params = { payload, id };

      updateDraft(params, {
        onSuccess: (res) => {
          handleToastMsg("Draft Data updated successfully", "success");
          setShowData([]);
          setFormValues({
            counts: "",
            machineNo: "",
            feedback: "",
          });
          queryClient.invalidateQueries("get-variety");
          queryClient.invalidateQueries({ queryKey: ["hariness"] });
          navigate("/hariness");
        },
        onError: (error) => {
          handleToastMsg("Draft Data Error Occurred", "error");
        },
      });
    } else {
      createDraft(showData[0], {
        onSuccess: (res) => {
          handleToastMsg("Draft Data updated successfully", "success");
          setShowData([]);
          setFormValues({
            counts: "",
            machineNo: "",
            feedback: "",
          });
          queryClient.invalidateQueries("get-variety");
          queryClient.invalidateQueries({ queryKey: ["hariness"] });
          navigate("/hariness");
        },
        onError: (error) => {
          handleToastMsg("Draft Data Error Occurred", "error");
        },
      });
    }
  };

  const [harinessCorrected, setHarinessCorrected] = useState("");
  const [harinessCorrectedError, setHarinessCorrectedError] = useState(false);

  const [saveAndSubmitDisabled, setSaveAndSubmitDisabled] = useState(true);
  const [finalSubmitDisabled, setFinalSubmitDisabled] = useState(false);

  const finalSubmitEnabled = () => {
    setFinalSubmitDisabled(true);
    setSaveAndSubmitDisabled(false);
  };

  const saveAndSubmitEnabled = () => {
    setSaveAndSubmitDisabled(true);
    setFinalSubmitDisabled(false);
  };

  const handleHarinessCorrected = (e) => {
    const value = e.target.value;
    const numericValue = value === "" ? "" : parseInt(value);

    if (value === "") {
      setHarinessCorrected("");
      setHarinessCorrectedError(false);
      saveAndSubmitEnabled();
    } else {
      if (!isNaN(numericValue)) {
        setHarinessCorrected(numericValue);
        if (
          state?.HarinessPayload?.hairness_errors?.number_of_errors <
          numericValue
        ) {
          setHarinessCorrectedError(true);
          saveAndSubmitEnabled();
        } else if (
          state?.HarinessPayload?.hairness_errors?.number_of_errors ===
          numericValue
        ) {
          setHarinessCorrectedError(false);
          finalSubmitEnabled();
          setShowData((prev) => {
            return prev.map((item) => {
              // Update the cot_buffing property of the specific item
              return {
                ...item,
                hairness_errors: {
                  ...item.hairness_errors,
                  corrected: numericValue,
                },
              };
            });
          });
        } else if (
          state?.HarinessPayload?.hairness_errors?.number_of_errors >
          numericValue
        ) {
          setHarinessCorrectedError(false);
          saveAndSubmitEnabled();
          setShowData((prev) => {
            return prev.map((item) => {
              // Update the cot_buffing property of the specific item
              return {
                ...item,
                hairness_errors: {
                  ...item.hairness_errors,
                  corrected: numericValue,
                },
              };
            });
          });
        }
      }
    }
  };

  const [remarks, setRemarks] = useState("");
  const handleRemarks = (e) => {
    const value = e.target.value;
    setRemarks(value);

    setShowData((prev) => {
      return prev.map((item) => {
        // Update the cot_buffing property of the specific item
        return {
          ...item,
          hairness_errors: {
            ...item.hairness_errors,
            remarks: value,
          },
        };
      });
    });
  };

  // Function to remove 'id' field from samples
  const removeIdFromSamples = (samples) => {
    return samples?.map(({ id, ...rest }) => rest);
  };

  const handleSubmit = async () => {
    //this is updated payload for final submit only (it remove the id in the hairness_records)
    const updatedPayload = {
      ...showData[0],
      hairness_records: removeIdFromSamples(showData[0]?.hairness_records),
    };

    if (!harinessCorrectedError && harinessCorrected !== "") {
      try {
        mutate(updatedPayload, {
          onSuccess: (res) => {
            handleToastMsg("Data updated successfully", "success");
            setShowData([]);
            setFormValues({
              counts: "",
              machineNo: "",
              feedback: "",
            });
            queryClient.invalidateQueries("get-variety");
            queryClient.invalidateQueries({ queryKey: ["hariness"] });
            queryClient.invalidateQueries("manager-spinning-notifications");
            navigate("/hariness");
          },
          onError: (error) => {
            handleToastMsg("Data Error Occurred", "error");
          },
        });
      } catch (error) {
        throw error;
      }
    }
  };

  const currentDate = dayjs().format("DD/MM/YYYY");

  return (
    <Container>
      <Grid mt={2} item xs={12}>
        <h2 className="heading">Hariness</h2>
      </Grid>
      <Grid mt={2} container spacing={2}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "1vw" }}>Date</TableCell>
                <TableCell style={{ width: "1vw" }}>No Of Cuts</TableCell>
                <TableCell style={{ width: "1vw" }}>Cots Buffing</TableCell>
                <TableCell style={{ width: "1vw" }}>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {showData.length > 0 &&
                showData?.map((item, index) => (
                  <>
                    <TableRow key={index}>
                      <TableCell style={{ width: "1vw" }}>
                        {currentDate}
                      </TableCell>
                      <TableCell style={{ width: "1vw" }}>
                        {item?.hairness_errors?.number_of_errors}
                      </TableCell>
                      <TableCell style={{ width: "1vw" }}>
                        <TextField
                          value={harinessCorrected}
                          onChange={(e) => handleHarinessCorrected(e)}
                          error={!!harinessCorrectedError}
                        />
                      </TableCell>
                      <TableCell style={{ width: "1vw" }}>
                        <TextField
                          value={remarks}
                          onChange={(e) => handleRemarks(e)}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid mt={3} item xs={10} sm={10}>
        <Textarea
          onChange={(e) => handleFormChange(e, "feedback")}
          name="Size"
          placeholder="Feedback (or) Any Queries"
          value={formValues.feedback}
        />
      </Grid>
      <Grid mt={3} item xs={10} sm={10}>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            style={{ width: "150px", height: "50px" }}
            onClick={() => handleSaveAndEdit()}
            disabled={
              !saveAndSubmitDisabled || isCreateLoading || isUpdateLoading
            }
          >
            {isCreateLoading || isUpdateLoading ? (
              <CircularProgress size={24} />
            ) : (
              "Save And Edit"
            )}
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            variant="contained"
            color="primary"
            style={{ width: "150px", height: "50px" }}
            onClick={handleSubmit}
            disabled={!finalSubmitDisabled || isSubmitLoading}
          >
            {isSubmitLoading ? <CircularProgress size={24} /> : "Final Submit"}
          </Button>
        </Box>
      </Grid>
    </Container>
  );
};

export default CountChange;
